import React, { useState } from "react";
import { Carousel, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MediaFileVM } from "../../../../types/viewModels/cmsPublic";
import "./styles.scss";

export interface NewsGalleryProps {
  images: MediaFileVM[];
}

const NewsGallery: React.FC<NewsGalleryProps> = ({ images }) => {
  const { t } = useTranslation("news");
  const [index, setIndex] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);

  if (images.length === 0) {
    return null;
  }

  const active = images[index] || images[0];

  return (
    <section className="w-100 my-5 news-gallery">
      <h2 className="h4">{t("gallery")}</h2>
      <hr className="custom-divider" />

      <Carousel
        activeIndex={index}
        onSelect={(selectedIndex) => setIndex(selectedIndex)}
        interval={null}
        indicators={images.length > 1}
        controls={images.length > 1}
      >
        {/* El DTO no trae `alt` ni thumbnails, así que se usa `name` como texto alternativo.
            La key incluye el índice porque el CMS permite repetir el mismo archivo. */}
        {images.map((image, position) => (
          <Carousel.Item key={`${image.url}-${position}`}>
            <img
              className="d-block w-100 news-gallery-img"
              src={image.url}
              alt={image.name}
              onClick={() => setShowLightbox(true)}
            />
          </Carousel.Item>
        ))}
      </Carousel>

      <Modal
        show={showLightbox}
        onHide={() => setShowLightbox(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton closeLabel={t("closeGallery")}>
          <Modal.Title className="h6">{active.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <img className="w-100" src={active.url} alt={active.name} />
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default NewsGallery;
